<template>
  <div>
    <div class="van-hairline--bottom">
      <van-field
        v-model="password"
        ref="password"
        type="password"
        :placeholder="$t('xmima','请输入新密码')"
        required
      />
    </div>

    <div class="van-hairline--bottom">
      <van-field
        v-model="confirmPassword"
        ref="confirmPassword"
        type="password"
        class="text-space"
        :placeholder="$t('qrxmima','确认密码')"
        required
      />
    </div>

    <ld-button
      :loading="submiting"
      :disabled="!validSuccess"
      class="submit-btn"
      @click.native="submit"
      main2
      size="lg"
    >
      {{ $t('B006','确定') }}
    </ld-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Field } from 'vant'
import ldButton from 'Common/ldButton'
import { validators } from 'Utils/valid'
import { ifStrBlank } from 'Utils/string'
import { sessionclear } from 'Utils/storage.js'

export default {
  components: {
    [Field.name]:Field,
    ldButton
  },
  data () {
    return {
      submiting: false,
      password: '',
      confirmPassword: ''
    }
  },
  created () {
    this.$store.commit('ResetPassword/SET_STEP', 3)
  },
  methods: {
    submit () {
      if (!validators.password(this.password).valid) {
        this.$validErrorTips(validators.password(this.password).msg)
        return
      }
      
      if (this.password !== this.confirmPassword) {
        this.$validErrorTips('两次密码不相符')
        return
      }
      
      this.submiting = true
      this.$api['user/vipEmpResetPwd']({
        phoneNumber: this.telphone,
        smsCode: this.validCode,
        pwd: this.password.trim()
      }).then(() => {
        this.submiting = false
        
        this.$dialog({
          message: '密码修改成功，请重新登录'
        }).then(() => {
          sessionclear()
          window.location.href = '#/login'
        })
      })
    }
  },
  computed: {
    ...mapState('ResetPassword', {
      telphone: state => state.telphone,
      validCode: state => state.validCode
    }),
    validSuccess() {
      return !ifStrBlank(this.password) && !ifStrBlank(this.confirmPassword)
    }
  }
}
</script>


